import { render } from "./OfferingStatusBadge.vue?vue&type=template&id=a5447a0e&scoped=true"
import script from "./OfferingStatusBadge.vue?vue&type=script&lang=js"
export * from "./OfferingStatusBadge.vue?vue&type=script&lang=js"

import "./OfferingStatusBadge.vue?vue&type=style&index=0&id=a5447a0e&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a5447a0e"]])

export default __exports__